import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useCleanupRedux } from '../../common/hooks'
import { apolloService } from '../../common/services'

import { LOCATION_TYPE_QUERY } from '../graphql/queries'
import { FETCH_LOCATION_TYPE } from '../redux/action-types'
import { cleanupFetchLocationType } from '../redux/actions'

const useLocationTypeQuery = id => {
  const dispatch = useDispatch()
  useCleanupRedux(cleanupFetchLocationType)

  const { isFetchLoading, fetchError, data } = useSelector(
    store => store.locationTypes.locationType,
  )

  const refetch = useCallback(
    id =>
      apolloService.query(
        LOCATION_TYPE_QUERY,
        { id },
        dispatch,
        FETCH_LOCATION_TYPE,
      ),

    [dispatch],
  )

  useEffect(() => {
    refetch(id)
  }, [id, refetch])

  return { isFetchLoading, fetchError, data }
}

export default useLocationTypeQuery
